/*
 * WW Sigma Steps — mobile card-scroller arrows
 * Author: Plaud Tayler — 2026-07-21
 * Version: 1.3.1 - 2026-09-22 17:05 (UTC+8) - Plaud Tayler — the overview rail's card joins the step-measure list, so it steps by a card rather than the 320 default
 * Version-note: 1.3.0 - 2026-09-22 16:10 (UTC+8) - Plaud Tayler — opt-in end states: a rail marked data-scroll-ends greys and disables the arrow it cannot move
 * Version-note: 1.2.0 - 2026-09-10 17:12 (UTC+8) - Plaud Tayler — the step selector names the two CSS
 *   scroll rails' card classes so they no longer fall through to the 320px default
 * Version-note: 1.1.0 - 2026-08-06 11:25 (UTC+8) - Plaud Tayler — swiper-aware: when the scroll target is (or sits inside) an initialized slide-section, arrows call slidePrev/slideNext instead of scrollBy — lets sections migrated to SlideSection/Swiper keep reusing this shared handler with zero section-local JS
 * Version-note: 1.0.0 - 2026-07-21 15:45 - Plaud Tayler — initial build (refreshed 393)
 * Scrolls the horizontal card row by one card per tap. Document-delegated; binds once.
 */
(function () {
  if (window.__wwSigmaStepsNav) return;
  window.__wwSigmaStepsNav = true;
  // FAQ mobile topic accordion (refreshed 10585:4860): toggle the topic's question list
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-faq-topic]');
    if (!t) return;
    var group = t.closest('.ww-sigma-faq__group');
    if (!group) return;
    var open = group.classList.toggle('is-open');
    t.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-steps-nav], [data-scroll-nav]');
    if (!btn) return;
    var dir = btn.getAttribute('data-steps-nav') || btn.getAttribute('data-scroll-nav');
    var section = btn.closest('section, .ww-sigma-steps');
    var list = null;
    var targetSel = btn.getAttribute('data-scroll-target');
    if (targetSel) list = section ? section.querySelector(targetSel) : document.querySelector(targetSel);
    else list = section && section.querySelector('.ww-sigma-steps__cards');
    if (!list) return;
    /* Swiper branch: target is (or sits inside) a slide-section — drive the swiper API;
       scrollBy is meaningless on a transform-driven track - Plaud Tayler - 2026-08-06 11:25 */
    var host = list.tagName === 'SLIDE-SECTION' ? list : (list.closest && list.closest('slide-section'));
    if (host && host.globalSlide && !host.globalSlide.destroyed) {
      if (dir === 'next') host.globalSlide.slideNext();
      else host.globalSlide.slidePrev();
      return;
    }
    /* Step measuring - Plaud Tayler - 2026-09-10 17:12
       The two CSS scroll rails on the Intelligence page hold neither an <li> nor a steps card,
       so they fell through to the 320 default and stepped by the wrong distance. Naming their
       card classes here changes nothing for the existing callers: a list that already matches
       the first two selectors never reaches these. */
    var card = list.querySelector('li, .ww-sigma-steps__card, .image-grid__item, .ww-plans__card, .ww-io__card');
    var step = card ? card.getBoundingClientRect().width + 16 : 320;
    list.scrollBy({ left: (dir === 'next' ? 1 : -1) * step, behavior: 'smooth' });
  });

  /* End states for the scroll rails - Plaud Tayler - 2026-09-22 16:10 - Begin
     An arrow at the end of a rail did nothing and said nothing: it stayed fully lit and a tap was
     silently swallowed. The pair now greys out and takes `disabled` at whichever end the rail is
     resting on — prev on load, next on the last card.

     OPT-IN, because this file is shared by five sections (image-grid, plans, home-quotes,
     sigma-agentic, sigma-explorer) and greying an arrow changes a signed-off look. A rail joins by
     carrying data-scroll-ends on the element that holds the buttons; the other consumers see no
     change at all.

     The swiper branch above is deliberately not covered: a slide-section can be looped, so "the
     end" is not a property of scrollLeft there, and it publishes isBeginning / isEnd of its own. */
  var TOL = 2;                    /* sub-pixel slack: a rail rarely rests on an exact integer */

  function railFor(btn) {
    var section = btn.closest('section, .ww-sigma-steps');
    var sel = btn.getAttribute('data-scroll-target');
    if (!sel) return section && section.querySelector('.ww-sigma-steps__cards');
    return section ? section.querySelector(sel) : document.querySelector(sel);
  }

  function sync(group) {
    var btns = group.querySelectorAll('[data-scroll-nav], [data-steps-nav]');
    for (var i = 0; i < btns.length; i++) {
      var btn = btns[i];
      var rail = railFor(btn);
      if (!rail) continue;
      /* A rail with nothing to scroll (the grid above the phone tier) disables both arrows rather
         than reporting "already at the end", which would light the prev one. */
      var room = rail.scrollWidth - rail.clientWidth;
      var dir = btn.getAttribute('data-scroll-nav') || btn.getAttribute('data-steps-nav');
      var off = room <= TOL ? true
        : dir === 'next' ? rail.scrollLeft >= room - TOL
        : rail.scrollLeft <= TOL;
      btn.disabled = off;
      btn.setAttribute('aria-disabled', off ? 'true' : 'false');
      btn.classList.toggle('is-disabled', off);
    }
  }

  function watch(group) {
    if (group.__wwNavEnds) return;
    group.__wwNavEnds = true;
    var seen = [];
    var btns = group.querySelectorAll('[data-scroll-nav], [data-steps-nav]');
    for (var i = 0; i < btns.length; i++) {
      var rail = railFor(btns[i]);
      if (!rail || seen.indexOf(rail) > -1) continue;
      seen.push(rail);
      rail.addEventListener('scroll', function () { sync(group); }, { passive: true });
      if (typeof ResizeObserver === 'function') {
        /* The rail's scrollWidth changes with the breakpoint and with lazy images landing, and
           neither fires a scroll event. */
        new ResizeObserver(function () { sync(group); }).observe(rail);
      }
    }
    sync(group);
  }

  function bindAll() {
    var groups = document.querySelectorAll('[data-scroll-ends]');
    for (var i = 0; i < groups.length; i++) watch(groups[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll, { once: true });
  } else {
    bindAll();
  }
  window.addEventListener('resize', function () {
    var groups = document.querySelectorAll('[data-scroll-ends]');
    for (var i = 0; i < groups.length; i++) sync(groups[i]);
  });
  document.addEventListener('shopify:section:load', bindAll);
  /* End states for the scroll rails - Plaud Tayler - 2026-09-22 16:10 - End */
})();
